import { Tabs } from 'antd'
import TabPane from 'antd/lib/tabs/TabPane'
import CustomModal from 'components/global/CustomModal'
import React, { useState } from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import NotesTab from '../Common/NotesTab'
import HistoryTab from '../Common/HistoryTab'
import CheckInOutTab from '../Common/CheckInOutTab'
import ApproveCheckIn from '../Common/ApproveCheckIn'

const ApproveCheckInModal = () => {
  const [tabKey, setTabKey] = useState<string>('1')

  const {
    approveCheckInModal,
    setCheckInOutModalOpen,
    setApproveCheckInModal,
    setParticipantData,
  } = eventAttendanceStore(store => ({
    approveCheckInModal: store.approveCheckInModal,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    setApproveCheckInModal: store.setApproveCheckInModal,
    setParticipantData: store.setParticipantData,
  }))

  const closeModal = () => {
    setParticipantData(null)
    setCheckInOutModalOpen(true)
    setApproveCheckInModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={approveCheckInModal}
        isCloseModalCustom
        closeModal={closeModal}
        title="Approve check-in"
        width={1200}
        footer={false}
      >
        <>
          <Tabs className="" defaultActiveKey={tabKey}>
            <TabPane tab="Approve check-in" key="1">
              <NotesTab />
            </TabPane>
            <TabPane tab="Check-in" key="2">
              <ApproveCheckIn />
            </TabPane>
            <TabPane tab="History" key="3">
              <HistoryTab />
            </TabPane>
          </Tabs>
        </>
      </CustomModal>
    </>
  )
}

export default ApproveCheckInModal
